<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>

      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <div class="cs-studyAbroad-accountList-conainter" v-show="!isShowAccountProfile">
              <el-row>
                <el-col :span="24">
                  <el-row>
                    <el-col>
                      <span class="cs-title">财务对账表</span>
                    </el-col>
                  </el-row>
                  <div v-loading="loadingDetails">
                    <el-row class="cs-studyAbroad-accountList-summary">
                      <el-col v-for="item in summaryDataList" :key="item.Currency" :span="12"
                        class="cs-studyAbroad-accountList-summary-item">
                        <el-row>
                          <el-col>
                            <span class="cs-totalAmount">{{
                            item.TotalSaleAmount | toCurrency(item.Currency)
                          }}</span>
                          </el-col>
                        </el-row>
                        <el-row class="cs-studyAbroad-amount">
                          <el-col :span="12">
                            所有{{getCurrencyDesc(item.Currency)}}收款
                          </el-col>
                          <el-col :span="12">
                            待核对(仅为筛选日期): {{ item.TotalUnchecked | toCurrency(item.Currency) }}
                          </el-col>
                        </el-row>
                        <el-row class="cs-studyAbroad-amount">
                          <el-col :span="12">
                            <!-- 手续费: {{ item.TotalServiceCharge | toCurrency(item.Currency) }} -->
                            欠款: {{ item.TotalDebt | toCurrency(item.Currency) }}
                          </el-col>
                          <el-col :span="12">
                            已核对(仅为筛选日期): {{ item.TotalChecked | toCurrency(item.Currency) }}
                          </el-col>
                        </el-row>
                        <el-row class="cs-studyAbroad-amount">
                          <el-col :span="24">
                            <span class="cs-blue cs-accountList-viewDetail" @click="viewDetails(item.Currency)">
                              查看明细
                              <i class="fa fa-chevron-down" v-if="!isShowPaymentDetails" aria-hidden="true"></i>
                              <i class="fa fa-chevron-up" v-if="isShowPaymentDetails" aria-hidden="true"></i>
                            </span>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <paymentDetails :currency="selectedCurrency" v-if="isShowPaymentDetails" :details="paymentDetailList">
                        </paymentDetails>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>

              <el-row class="cs-accountList-topbar">
                <el-col :span="5" class="cs-accountList-checkPayment">
                  <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="searchPhone"
                    @keyup.enter.native="onSearch()">
                  </el-input>
                </el-col>
                <el-col :span="8" class="cs-accountList-padding">
                  <el-date-picker class="cs-accountList-searchDate" v-model="searchDate" type="daterange" align="center"
                    unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :picker-options="pickerOptions" size="medium" :clearable="false"></el-date-picker>
                </el-col>

                <el-col :span="8" class="cs-accountList-checkPayment">
                  <el-button type="primary" size="medium" @click="onSearch()">搜索</el-button>

                  <el-button :type="paymentCheckBtnClass" v-if="!paginationStatus.isChecking && !ischeckDisabled" size="medium" @click="checkPayment">
                    开始核对</el-button>
                  <el-button class="" type="primary" v-if="paginationStatus.isChecking && !ischeckDisabled" size="medium" @click="cancelCheckPayment">
                    取消</el-button>
                  <el-button type="primary" v-if="paginationStatus.isChecking && !ischeckDisabled" :disabled="isSavingPaymentCheck" size="medium"
                    @click="saveCheckPayment">保存</el-button>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="5" class="">
                  <el-select placeholder="请选择" v-model="selectedUniversity" size="medium">
                    <el-option v-for="item in universityList" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="5" class="cs-accountList-padding">
                  <el-select v-model="selectedBusinessType" size="medium">
                    <el-option v-for="item in businessTypeList" :key="item.key" :label="item.desc" :value="item.value" />
                  </el-select>
                </el-col>
                <el-col :span="5" class="cs-accountList-padding">
                  <el-select placeholder="请选择" v-model="selectedCategory" size="medium">
                    <el-option v-for="item in categoryList" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="5" class="cs-accountList-padding" v-if="USERMANAGER.isAdmin || USERMANAGER.isSAManager">
                  <el-select placeholder="请选择" v-model="selectedEmployeeId" size="medium" filterable>
                    <el-option :key="0" label="所有行政人员" :value="0"/>
                    <el-option v-for="item in employeeListData" :key="item.Id" :label="item.Name" :value="item.Id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row class="grid-content">
                <el-col>
                  <pagination :status="paginationStatus" v-loading="loading" :data="listData" :option="paginationOption"
                    @search="search" @edit="showAccountProfile" @searchWithOption="searchWithOption" @loadData="onLoadAccountList"
                    @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange">
                    <template #BusinessType="{row, col}">
                      <span>{{GLOBAL.enumBusinessType.getDesc(row[col.Field])}}</span>
                    </template>
                  </pagination>
                </el-col>
              </el-row>
            </div>
            <div class="cs-studyAbroad-accountProfile-conainter" v-show="isShowAccountProfile">
              <saAccountProfile :dataIn="dataForAccountProfile" @close="closeAccountProfile" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-studyAbroad-accountList-summary {
  .cs-studyAbroad-accountList-summary-item {
    &:first-of-type {
      border-right: 1px solid #ced3d9;
      padding-right: 30px;
    }

    &:last-of-type {
      padding-left: 30px;
    }
  }
  margin-bottom: 20px;
}
.cs-contentContainer {
  .cs-main-right-container {
    .cs-contentContainer-right-content {
      padding: 0px !important;
      .cs-studyAbroad-accountList-conainter {
        padding: 40px;

        .cs-accountList-topbar {
          margin-bottom: 10px;
        }
        .cs-accountList-padding {
          padding-left: 15px;
        }
        .cs-accountList-checkPayment {
          text-align: right;

          button {
            display: inline-block;
          }
        }

        .cs-totalAmount {
          font-size: 30px;
          font-weight: bold;
        }

        .cs-studyAbroad-amount {
          padding-bottom: 10px;

          .cs-grey {
            color: grey;
          }
          .cs-blue {
            color: #006ab4;
          }

          .cs-accountList-viewDetail {
            cursor: pointer;
          }

          span {
            display: inline-block;
            margin-right: 20px;
            width: auto;
          }

          .fa {
            margin-left: 3px;
          }
        }

        .cs-accountList-searchDate {
          width: auto;

          .el-range-separator {
            z-index: 99;
          }
        }
      }
    }
  }
}
</style>

<script>
import { getUniversities } from "../../service/common.service";
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import paymentDetails from "../../components/finance/paymentDetails";
import { getEmployees } from "@/service/user.service";

import {
  checkPayment,
  resetAccountHighlight,
} from "../../service/finance.service";

import {
  getAccountList,
  getAccountSummaryList,
} from "../../service/studyAbroad.service";

import { formatDate } from "../../config/mUtils.js";

export default {
  data() {
    return {
      selectedCategory: "",
      selectedUniversity: "",
      selectedBusinessType: "",
      selectedEmployeeId: 0,
      universityList: [],
      businessTypeList: [],
      employeeListData: [],
      ischeckDisabled: this.USERMANAGER.isSABusinessSales || this.USERMANAGER.isSABusinessAssistant,
      
      loading: false,
      loadingDetails: false,
      listData: {},
      originalListData: {},
      pageSize: 20,
      paginationOption: {},
      paginationStatus: {
        isChecking: false,
      },
      paymentCheckBtnClass: "primary",
      isSavingPaymentCheck: false,

      searchDate: "",
      searchPhone: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      isShowAccountProfile: false,
      dataForAccountProfile: {
        workflowId: 0,
        account: null,
      },
      paymentDetailList: [],
      isShowPaymentDetails: false,
      selectedCurrency: 2,
      paymentCheckChangeList: [],
      accountCheckChangeList: [],

      summaryDataList: [],
    };
  },
  components: {
    navigator,
    pagination,
    paymentDetails,
    saAccountProfile: () => import("@/components/studyAbroad/accountProfile"),
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    getCurrencyDesc(currency) {
      if (currency == this.GLOBAL.currencyType.CAD) {
        return "CAD";
      } else {
        return "CNY";
      }
    },
    async init() {
      this.categoryList = [];
      this.categoryList.push({ key: 0, value: "所有核对类型" });
      this.categoryList.push({ key: 4, value: "只显示已核对" });
      this.categoryList.push({ key: 3, value: "只显示未核对" });
      this.selectedCategory = 0;

      this.businessTypeList = JSON.parse(JSON.stringify(this.GLOBAL.enumBusinessType.getOptions()));
      this.businessTypeList.splice(0, 0, {key: 0, value: 0, desc: "所有业务类型"});
      this.selectedBusinessType = 0;

      this.searchDate = [];
      let today = new Date();
      this.searchDate.push(today);
      this.searchDate.push(today);

      this.loadUniversityList();
      this.getEmployeeListData();

      this.paginationOption = {
        displayPagination: true,
        hasEditButton: true,
        editButtonText: "查看详情",
        hasAddButton: false,
        hasSearch: false,
        hasDateSearch: false,
      };

      this.loadAccountSummaryList();
      this.search();
    },
    async loadUniversityList() {
      this.universityList = [];
      this.universityList.push({ key: 0, value: "所有学校" });
      let result = await getUniversities();
      if (!!result && result.success) {
        result.data.forEach((i) => {
          this.universityList.push({ key: i.Key, value: i.Value });
        });
      }
      this.selectedUniversity = 0;
    },
    viewDetails(currency) {
      this.selectedCurrency = currency;
      this.isShowPaymentDetails = !this.isShowPaymentDetails;
      if (this.isShowPaymentDetails) {
        this.paymentDetailList = this.summaryDataList.find(
          (i) => i.Currency == currency
        ).PaymentDetails;
      }
    },
    async loadAccountSummaryList() {
      this.loadingDetails = true;
      let pageData = this.getSearchPageData();
      await getAccountSummaryList(pageData)
        .then((result) => {
          if (result && result.success) {
            this.summaryDataList = result.data;

            if (this.isShowPaymentDetails) {
              this.paymentDetailList = this.summaryDataList.find(
                (i) => i.Currency == currency
              ).PaymentDetails;
            }
          }
          this.loadingDetails = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingDetails = false;
        });
    },
    saveCheckPayment() {
      if (this.isSavingPaymentCheck) {
        return;
      }

      this.getPaymentCheckChangeList();
      let paymentCheckList = [];
      this.paymentCheckChangeList.forEach((element) => {
        let paymentCheck = this.getPaymentCheck(element);
        if (!!paymentCheck) {
          paymentCheckList.push(paymentCheck);
        }
      });
      this.isSavingPaymentCheck = true;
      checkPayment(paymentCheckList, this.accountCheckChangeList).then(
        (result) => {
          this.isSavingPaymentCheck = false;
          if (result.success) {
            this.$message({
              message: "保存核对成功",
              type: "success",
            });

            this.originalListData = JSON.parse(JSON.stringify(this.listData));
            if (this.accountCheckChangeList.length > 0) {
              this.reloadData();
            }

            this.paymentCheckChangeList = [];
            this.accountCheckChangeList = [];
          } else {
            this.$message({
              message: result.message,
              type: "error",
            });
          }
          this.paginationOption.hasEditButton = true;
        }
      );
      this.$set(this.paginationStatus, "isChecking", false);
      this.paymentCheckBtnClass = "primary";
    },
    cancelCheckPayment() {
      this.paymentCheckChangeList = [];
      this.accountCheckChangeList = [];
      this.$set(this.paginationStatus, "isChecking", false);
      this.paymentCheckBtnClass = "primary";
      this.listData = JSON.parse(JSON.stringify(this.originalListData));
      this.paginationOption.hasEditButton = true;
    },
    checkPayment() {
      this.paymentCheckChangeList = [];
      this.accountCheckChangeList = [];
      this.$set(this.paginationStatus, "isChecking", true);
      this.paymentCheckBtnClass = "info";
      this.paginationOption.hasEditButton = false;
    },
    getPaymentCheck(accountPayment) {
      if (!accountPayment) {
        return false;
      }
      if (!accountPayment.Id) {
        return false;
      }

      let paymentCheckData = {
        Key: accountPayment.Id,
        Value: accountPayment.IsChecked,
      };
      return paymentCheckData;
    },
    onSearch() {
      this.reloadData();
    },
    reloadData() {
      this.search();
      this.loadAccountSummaryList();
    },
    onLoadAccountList(pageData) {
      this.search(pageData.pageNumber);
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let startDate = "";
      let endDate = "";
      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = formatDate(this.searchDate[0]);
        endDate = formatDate(this.searchDate[1]);
      }

      let filterList = {
        category: this.selectedCategory,
        universityId: this.selectedUniversity,
        businessType: this.selectedBusinessType,
        employeeId: this.selectedEmployeeId,
      };

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchPhone,
        startDate: startDate,
        endDate: endDate,
        additionalFilter: filterList,
      };
      return pageData;
    },
    searchWithOption(option) {},
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      if (!pageData.startDate || !pageData.endDate) {
        this.$warrning("请输入有效的日期范围");
        return;
      }
      this.loadAccountListData(pageData);
    },
    checkIsHighlight(row) {
      if (row.IsHighlight) {
        resetAccountHighlight(row.Id).then((result) => {
          if (!!result && result.success) {
            row.IsHighlight = false;
          }
        });
      }
    },
    showAccountProfile(index, row) {
      this.reloadAccountProfileData(row);
      this.checkIsHighlight(row);
      this.isShowAccountProfile = true;
    },
    reloadAccountProfileData(account) {
      this.dataForAccountProfile = {
        workflowId: account.WorkflowId,
      };
    },
    closeAccountProfile(isReload) {
      this.isShowAccountProfile = false;
      if (isReload) {
        this.reloadData();
      }
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getPaymentCheckChangeList() {
      let length = this.listData.Results.length;
      for (let i = 0; i < length; i++) {
        let item = this.listData.Results[i];
        let itemOriginal = this.originalListData.Results[i];

        if (!!item.AccountPayment1) {
          if (!item.AccountPayment1.Id) {
            if (item.AccountPayment1.IsChecked) {
              if (this.accountCheckChangeList.indexOf(item.Id) < 0) {
                this.accountCheckChangeList.push(item.Id);
              }
            }
          } else {
            this.addPaymentCheckChangeListItem(
              item.AccountPayment1,
              itemOriginal.AccountPayment1
            );
            this.addPaymentCheckChangeListItem(
              item.AccountPayment2,
              itemOriginal.AccountPayment2
            );
            this.addPaymentCheckChangeListItem(
              item.AccountPayment3,
              itemOriginal.AccountPayment3
            );
            this.addPaymentCheckChangeListItem(
              item.AccountPayment4,
              itemOriginal.AccountPayment4
            );
          }
        }
      }
    },
    addPaymentCheckChangeListItem(accountPayment, accountPaymentOriginal) {
      if (!accountPayment || !accountPaymentOriginal) {
        return;
      }
      if (accountPayment.IsChecked != accountPaymentOriginal.IsChecked) {
        let index = this.paymentCheckChangeList.findIndex((i) => {
          if (i.Id == accountPayment.Id) {
            return true;
          } else {
            return false;
          }
        });
        if (index < 0) {
          this.paymentCheckChangeList.push(accountPayment);
        }
      }
    },
    loadAccountListData(pageData) {
      this.loading = true;
      getAccountList(pageData)
        .then((result) => {
          if (result && result.success) {
            this.listData = result.data;
            this.originalListData = JSON.parse(JSON.stringify(this.listData));
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    async getEmployeeListData() {
      let roleTypes = this.GLOBAL.roleType
        .getOptionsByKeys([
          "saBusinessSales",
          "saBusinessAssistant",
          "saBusinessManager",
          "saFinancialAssistant",
          "saFinancialManager",
        ])
        .map((enumOption) => enumOption.value);

      let result = await getEmployees(roleTypes, "", null);
      if (result && result.success) {
        this.employeeListData = result.data.Results.map((i) => {
          return { Id: i.UserId, Name: i.Name };
        });
      } else {
        this.employeeListData = [];
      }
    },
  },
  watch: {},
};
</script>
 



// WEBPACK FOOTER //
// src/page/studyAbroad/accountList.vue